(function() {
  const initSlider = () => {
    document.querySelectorAll('.js-image-slider-with-text').forEach(container => {
      if (container.classList.contains('swiper-initialized')) return;

      const spaceBetween = parseInt(container.getAttribute('data-space-between')) || 20;
      
      new Swiper(container, {
        slidesPerView: 1.5,
        centeredSlides: false,
        spaceBetween: 8,
        loop: false,
        navigation: {
          nextEl: container.querySelector('.swiper-button-next'),
          prevEl: container.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          990: {
            slidesPerView: 2.5,
            spaceBetween: spaceBetween
          }
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initSlider);
  
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initSlider);
  }
})();
